<template>
    <div class="mx-0">
        <p v-if="talks.length == 0" class="body-2 font-weight-bold mx-3 mt-4 px-0 px-sm-2 mt-0"> 0 Matches </p>
        <v-card v-for="(programme, index) in talks" :key="index" class="mx-0 px-0 my-2" width="100%">
            <v-overlay v-if="deleting==programme.id" :absolute="true" :value="true">
                <v-icon x-large color="red darken-2">
                    not_interested
                </v-icon>

            </v-overlay>

            <v-card-text class="mx-1 px-0 px-sm-2 mt-0">
                <div>
                    <router-link
                        :to="{name:'event',params:{id:programme.id}}"
                        class="text-h6 font-weight-bold black--text mx-0 mt-n2 mb-1 mb-sm-2 pr-2 justify"
                        tag="a">
                        {{programme.title}}
                    </router-link>
                    <p class="orange--text text-body-1 font-weight-bold text--darken-3 my-0" v-html="programme.speaker">
                    </p>
                    <p v-if="programme.affiliation" class="body-2 font-weight-regular ml-0 grey--text text--darken-2 my-0"
                        v-html="programme.affiliation"></p>
                    <p class="pl-0 body-2 pt-1 pb-2 font-weight-bold">{{programme.dateAll}}
                        <span v-html="programme.place"></span>
                    </p>
                    <p v-if="getAllText(index)" v-html="programme.text"
                        class="body-2 font-weight-regular ml-0  mr-2  mt-0 mt-sm-1 black--text justify ql-ed">
                    </p>
                    <app-text-programme-more v-else :textMore="programme.text"></app-text-programme-more>
                    <a v-if="programme.file_url" class=" indigo--text text--darken-2 font-weight-bold"
                        :href="programme.file_url" target="_blanc">
                        <p class="ml-3 mr-2 text-body-2 my-1">
                            {{programme.file_description}}
                            <img v-if="!mobile" src="../../../assets/research/acrobat_icon.png" class="pl-1 pb-1">
                            <span v-else class="text-body-2 purple--text text--purple-4 pl-1"> Download PDF</span>
                        </p>
                    </a>
                    <div v-if="bo">
                        <v-btn x-small class="mt-0 ml-2 white--text" color="green darken-4"
                            :to="{name:'seminar.program.edit.bo',params:{id:programme.id}}">
                            edit
                        </v-btn>
                        <item-mutate :mutation="'delete'" :type="'talk'" :disabled="false" :item="programme"
                            :mutationEndpoint="'/index.php/api/events/talks/destroy/'"
                            @onMutateSuccess="onDeleteSuccess" @onMutateRequest="onDeleteRequest(programme.id)"
                            @onMutateFailed="onDeleteFinish" @onMutateFinish="onDeleteFinish">
                        </item-mutate>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>

import textProgrammeMore from './TextProgrammeMore.vue';
import ItemMutate from '../../sharing/ItemMutate.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
    props: {
        bo: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ie: false,
            deleting: -1
        };
    },
    created() {
        if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
            this.ie = true;
        }
    },
    computed: {
        ...mapGetters('talks', {
            year: 'year',
            talks: 'talks',
        }),
        ...mapGetters('header', {
            mobile: 'mobile',
        })
    },
    components: {
        AppTextProgrammeMore: textProgrammeMore,
        ItemMutate
    },
    methods: {
        ...mapMutations('talks', ['DELETE_TALK',]),
        getAllText(index) {
            if (this.mobile) {
                return false;
            }
            // else if(index == 0 || this.ie)
            //     return true;
            else
                return true;
        },
        onDeleteSuccess() {
            this.DELETE_TALK(this.deleting);
            this.deleting = -1;
        },
        onDeleteRequest(id) {
            this.deleting = id;
        },
        onDeleteFinish() {
            this.deleting = -1;
        }
    }
}
</script>
<style scoped>
.nojustify {
    /* text-align: justify; */
    /* text-justify: inter-word; */
    text-justify: none;
}

.justify {
    text-align: justify;
    text-justify: inter-word;

}

.date {
    border-left-color: orange;
    border-left-width: 2pt;
    border-left-style: groove;
}

.read-more-button {
    margin-top: 0em !important;
    padding-top: 0.1em !important;
}
</style>
